import React from "react";

import * as Yup from "yup";
import { Field, Form, Formik } from "formik";
import { Input } from "../../../../../../_metronic/_partials/controls";
import { IOSSwitch } from "../../../../../../_metronic/_partials/controls/forms/IosSwitch";
import { FormControlLabel } from "@material-ui/core";

const InvestigationEditSchema = Yup.object().shape({
    description: Yup.string(),
});

const InvestigationEditForm = ({
                                   investigation,
                                   btnRef,
                                   saveInvestigation,
                               }) => {
    return (
        <>
            <Formik
                initialValues={investigation}
                onSubmit={(values) => saveInvestigation(values)}
                validationSchema={InvestigationEditSchema}
                enableReinitialize={true}
            >
                {({ handleSubmit, setFieldValue, values }) => (
                    <>
                        {values && (
                            <Form className={"form form-label-right"}>
                                <div className={"form-group row"}>
                                    <div className={"col-lg-8"}>
                                        <Field
                                            name={"description"}
                                            component={Input}
                                            label={"توضیحات"}
                                            type={"text"}
                                            useQuill={true}
                                        />
                                    </div>
                                </div>

                                <button
                                    type={"submit"}
                                    style={{ display: "none" }}
                                    ref={btnRef}
                                    onSubmit={() => handleSubmit()}
                                />
                            </Form>
                        )}
                    </>
                )}
            </Formik>
        </>
    );
};

export default InvestigationEditForm;
